<template lang="pug">
  div.background
    img(
      :src="src"
      :srcset="srcset"
    )
    slot
</template>

<style lang="scss" scoped>
.background img {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
  background-attachment: fixed;
}
</style>

<script>
const purposeTypes = {
  default: { name: 'bg' },
}

export default {
  props: {
    purpose: {
      default: 'default',
      validator: function (value) {
        return Object.keys(purposeTypes).indexOf(value) !== -1
      },
    },
  },
  computed: {
    src() {
      return this.assetPath(
        `retina-images/${purposeTypes[this.purpose].name}.jpg`
      )
    },
    srcset() {
      return this.assetSrcSet(
        `retina-images/${purposeTypes[this.purpose].name}.jpg`
      )
    },
  },
}
</script>
